/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandalonePageMeta from 'base/components/standalone/PageMeta';

export const DynamicStandalonePageMeta = StandalonePageMeta;
export type DynamicStandalonePageMetaProps = PropsFromComponent<typeof StandalonePageMeta>;

export const DynamicStandalonePageMetaWith = (extras: DynamicStandaloneExtras): typeof StandalonePageMeta => {
    return function DynamicStandalonePageMeta(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'PageMeta');
        return <StandalonePageMeta {...mergeProps({ options: { theme } }, props)} />;
    }
}